// ws/service-error-notice.js: what the player sees for the room-ws
// service's own errors (batch B3a round 4, item 4).
//
// A code the player can act on shows on screen in plain words. Every
// other code needs no action: the connection banner, "Sending…" or the
// locked controls already say what is going on, so it only goes to
// console.warn. Every code is warned, so none is dropped silently.

/** Codes the player can act on, with the words to show. */
const ON_SCREEN = {
  // Nothing retries after this; a reload is the way out.
  WS_CONSTRUCT_FAILED: 'Could not connect to the game server. Reload the page to try again.',
};

/**
 * @param {{ code: string, message?: string }} err
 * @returns {{ screen: string|null }}
 */
export function serviceErrorNotice(err) {
  return { screen: ON_SCREEN[err?.code] ?? null };
}

/**
 * Warn with the code, and show the error when the player can act on it.
 * @param {{ code: string, message?: string }} err
 * @param {(notice: { code: string, message: string }) => void} show
 */
export function reportServiceError(err, show) {
  console.warn(`[room-ws] ${err?.code}: ${err?.message ?? ''}`);
  const { screen } = serviceErrorNotice(err);
  if (screen) show({ code: err.code, message: screen });
}
